
<section class="account-page" id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header"><h3 class="title" i18n="@@manageSubscriptionLabel">Manage Subscription</h3></div>
      <div *ngIf="isLoading" class="page-content loading-wrapper">
        <i class="fa fa-circle-o-notch fa-spin fa-5x"></i>
      </div>
      <div *ngIf="!isLoading" class="page-content page-loaded">
        <div class="plan-list">
          <app-plan-view
            *ngFor="let plan of plans; index as index"
            [plan]="plan"
            [ngClass]="(selectedPlan === index ? 'selected' : 'unselected') + (activePlan === index ? ' active' : '')"
            (selectPlan)="onPlanSelect(plan, index)"
          ></app-plan-view>
        </div>
      </div>
      <div class="header payment-method"><h3 class="title" i18n="@@managePaymentMethodLabel">Payment Method</h3></div>
      <app-payment-method-form [isNewPlan]="activePlan !== selectedPlan" [selectedPlan]="plans[selectedPlan]"></app-payment-method-form>
    </section>
  </section>
</section>
